import { commentItems } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            读者热议
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自真实读者的声音，看看大家对51黑料网的评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold text-sm">
                  {item.author.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-sm md:text-base text-foreground-900">
                    {item.author}
                  </div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {item.content}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line text-sm"></i>
                  {item.likes.toLocaleString()}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">回复</span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">举报</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}